module.exports = __webpack_public_path__ + "static/media/WEBPedex.0459672b.webp";